export const PUBLIC_URL = import.meta.env.VITE_PUBLIC_URL;
export const API_URL = import.meta.env.VITE_REACT_APP_API_URL;
export const API_HOST = API_URL.replace(/\/api$/, "");
export const LN_ENV = import.meta.env.VITE_REACT_APP_LN_ENV;

export const anonPaths = [ "LOGIN", "LOGIN_NEW_PASSWD","LOGIN_REGISTER", "LOGIN_VERIFY_EMAIL"];

export const browserLanguage = 
  (navigator.languages && navigator.languages.length && navigator.languages[0])
  || navigator.language
  || 'en';


  export const GradeJudgement = {
  NotSet: 0,
  Failed: 1,
  Approved: 2,
  ApprovedPlus: 3
}

let _release = null;
const meta:Element | null = document.querySelector('meta[name="portal-release"]');
if (meta) {
  _release = meta.attributes.getNamedItem("content")?.value;
}

if (_release === "%VERSION%") {  // localhost
  _release = null;
}
export const release = _release;


/**
 * @type {number}
 */
export const MAIL_POLL_INTERVAL_IN_SEC = 10;

// time to keep cached part in redux before new fetch at server
export const MINUTES_PART_CACHE = 5;

export const flagUrls = {
  "da-dk": '/imgs/flag_da.svg',
  "en-gb": '/imgs/flag_en.svg',
  "sv-se": '/imgs/flag_sv.svg'
}

export const customLayouts = {
  None: 0,
  PFIZER_LAYOUT : 1
};

export const endPoint = {
  API_URL: API_URL,
  API_HOST: API_HOST,
  LOGIN_URL: '/login/login',
  LOGOUT_URL: '/login/logout',
  LANGUAGES_URL: '/languages',
  SET_LANG_URL: '/language',
  PING_URL: '/login/ping',


  GET_CONFIGDATA_URL: '/configs',

  GET_UNIT_IMAGE_URL: (unitId:string)=>  `${API_URL}/unit/${unitId}/image`,

  LOGIN_DATA_URL: (lang:string) => `/login/logindata?langid=${lang}`,
  LOGIN_WELCOME_SCREEN: '/login/logindata?langid=',
  FORGOT_PASSWORD_URL: '/login/resetpassword',
  CHANGE_PASSWORD: '/login/ChangePasswd',
  GET_TEXT_DICTIONARY: (lang:string) => `/languages/strings/${lang}`,


  /* TEACHER */
  TEACHER_DASHBOARD_URL: (date:string) => `/dashboard/?start=${date}`,
  TEACHER_NAVBAR_URL: `/navbar`,
  TEACHER_ALL_CLASSES_URL: () => `/class/teacherclasses`,
  TEACHER_CLASS_DATA_URL: ({classid, date}:{classid:string, date:string}) => `/dashboard/class/${classid}/teacher?lastVisit=${date}`,

  /* SEARCH */
  SEARCH_URL: (text:string, page:string) => `/search/?text=${text}&page=${page}`,


  /* CLASS */
  ALL_CLASSES_STUDENT_URL: '/class/GetClassesForStudent',

  DASHBOARD_AND_CLASS_URL: (classid:string, date:string) => `/class/${classid}/alldata?start=${date}`,
  CLASS_INFO_URL: (classid:string) => `/class/${classid}/info`,
  RESEND_VERFICATION_CODE_URL: `/class/resendcode`,
  VERFY_CODE_URL: `/class/VerifyCode/`,

  GET_PART_URL: (classid:string, partId:string) => `/class/${classid}/coursepart/${partId}`,
  CLASS_OVERVIEW_URL: () => `/class/overview`,
  GET_CLASS_CERTIFICATE_URL: (userId:string, classid:string) => `/diploma/${userId}/${classid}/get`,

  /* CLASS  TEACHER*/
  CLASS_ACTIVITY_URL: (classid:string) => `/class/${classid}/fullprogress`,
  CLASS_WATCHED_URL: (classid:string) => `/class/${classid}/watched`,
  CLASS_OPENED_LINKS_URL: (classid:string) => `/class/${classid}/watched/links`,
  CLASS_OPENED_FILES_URL: (classid:string) => `/class/${classid}/watched/files`,

  /* CLASS  NOTIFICATIONS*/
  CLASS_NOTIFICATIONS_URL: (classid:string) => `/class/${classid}/notification/list`,
  CLASS_NOTIFICATIONS_EDIT_URL: (classid:string) => `/class/${classid}/notification/list/edit`,
  CLASS_NOTIFICATION_EDIT_URL: (classid:string, notificationId:string) => `/class/${classid}/notification/${notificationId}`,
  CLASS_NOTIFICATION_NEW_URL: (classid:string) => `/class/${classid}/notification/create`,
  CLASS_NOTIFICATION_DELETE_URL: (classid:string, id:string) => `/class/${classid}/notification/${id}`, // use DELETE

  /* TIMETABLE */
  CLASS_START_TIMETABLE_URL: (classid:string) => `/class/${classid}/timetable`,
  CLASS_EDIT_EVENT_DATA_URL: (classid:string) => `/class/${classid}/timetable/editor`,
  CLASS_TIMETABLE_GET_EVENTS_CLASS_ONLY_URL: (classid:string, start:number, end:number, teacherOnly:boolean) => `/class/${classid}/timetable/events/fc?start=${start}&end=${end}${ teacherOnly ? "&teacherOnly=true": ""}`,
  CLASS_TIMETABLE_GET_EVENTS_OTHER_CLASSES_URL: (classid:string, start:number, end:number, teacherOnly:boolean) => `/class/${classid}/timetable/events/fc/exclude?start=${start}&end=${end}${ teacherOnly ? "&teacherOnly=true": ""}`,
  CLASS_TIMETABLE_GET_EVENTS_UNIT_CLASSES_URL: (classid:string, start:number, end:number ) => `/class/${classid}/timetable/events/allforunit?start=${start}&end=${end}`,
  CLASS_TIMETABLE_GET_EVENTS_SELECTED_CLASSES_URL: (classid:string, start:number, end:number ) => `/class/${classid}/timetable/events/forClasses?start=${start}&end=${end}`,

  TIMETABLE_GET_EVENT_DETAILS_URL: (id:string|number) => `/event/${id}`,
  TIMETABLE_DELETE_EVENT_URL: (id:number) => `/event/${id}`,
  TIMETABLE_GET_CHECK_EVENT_URL: `/event/check`,
  TIMETABLE_GET_POST_EVENT_URL: `/event`,
  TIMETABLE_GET_USER_DEFAULT_TIMES_URL: `/timetable/DefaultTimes`,



  /* FEED */
  // filterType: ByPosts=0 | ByComments=1   userId?: string
  CLASS_FEED_START_URL: (classid:string, userId:string, filterType:number|string) => `/class/${classid}/feed?filtertype=${filterType}&filterByUser=${userId}`,
  CLASS_MORE_FEED_URL: (feedId:string, postId:number, userId:string, filterType:number|string) => `/feed/${feedId}?after=${postId}&filterByUser=${userId}}&filterType=${filterType}`,
  CLASS_CREATE_FEED_URL: (feedId:string) => `/feed/${feedId}/post`,
  CLASS_UPDATE_FEED_URL: (feedId:string, postId:number) => `/feed/${feedId}/post/${postId}`,
  CLASS_CREATE_FEED_COMMENT_URL: (feedId:string, postId:number) => `/feed/${feedId}/post/${postId}/comment`,
  CLASS_UPDATE_FEED_COMMENT_URL: ( commentId:number|string,  feedId:string, postId:number) => `/feed/${feedId}/post/${postId}/comment/${commentId}`,
  CLASS_GET_ONE_FEEDPOST_URL: (feedId:string, postId:number) => `/feed/${feedId}/post/${postId}`,
  CLASS_GET_ONE_FEEDCOMMENT_URL: (feedId:string, postId:number, commentId:number) => `/feed/${feedId}/post/${postId}/comment/${commentId}`,
  FEED__ALL_COMMENTS_URL: (feedId:string, postId:number) => `/feed/${feedId}/post/${postId}/comment`,

  /* FORUM */
  CLASS_FORUM_START_URL: (classid:string, userId:string, filterType:number|string) => `/class/${classid}/forum?filtertype=${filterType}&filterByUser=${userId}`,
  CLASS_CUEPOINT_FORUM_START_URL: (classid:string, threadId:number,) => `/class/${classid}/${threadId}/forumForCuePoint`,
  /**
  //* @param {{forumId:string, page:number, sortBy:number, desc:boolean, userId: null | string, filterType: null | 0 | 1}}
  */
  MORE_FORUM_URL: (forumId:string, page:number, sortBy:string, desc:boolean|string, userId:string, filterType:number|string) => `/forum/${forumId}?page=${page}&by=${sortBy}&desc=${desc}&filtertype=${filterType}&filterByUser=${userId}`,
  GET_THREAD_URL: (forumid:string, threadid:number|string) => `/forum/${forumid}/thread/${threadid}`,
  GET_CREATE_THREAD_URL: (forumid:string) => `/forum/${forumid}/thread`,
  GET_UPDATE_POST_URL: (id:number) => `/forum/post/${id}/update`,
  GET_FORUM_READERS_URL: (forumid:string, threadid:number|string) => `/forum/${forumid}/thread/${threadid}/readBy`,
  GET_FORUM_PUBLISH_URL: (forumid:string, threadid:number|string) => `/forum/${forumid}/thread/${threadid}/publish`,
  GET_FORUM_NEW_POSTS_URL: (forumid:string, epoch:number) => `/forum/${forumid}/${epoch}/newheaders`,
  GET_SET_THREAD_AS_READ_URL: (forumid:string) => `/forum/${forumid}/setAllAsRead`,
  GET_SET_FORUM_SUBSCRIPTION: (forumid:string, sendTo:number|string) => `/forum/${forumid}/${sendTo}/subscribe`,
  GET_DELETE_FORUM_SUBSCRIPTION: (forumid:string) => `/forum/${forumid}/unsubscribe`,
  GET_TEST_FOR_CONNECTION_URL: (forumid:string) => `/forum/${forumid}/thread/TestsForConnection`,

  /*  FEEDBACK */
  GET_POST_FEEDBACK_URL: () => `/feedback`,
  GET_USER_FEEDBACK_URL: () => `/feedback/UserFeedbacks`,

  /*  EMAIL TO CLASS */
  GET_CREATE_MAIL_FOR_CLASS_URL: () => `/mail/bulk`,
  GET_MAIL_LIST_FOR_CLASS_URL: (classid:string) => `/class/${classid}/mail`,
  GET_MAIL_FOR_CLASS_URL: (classid:string, projid:number) => `/class/${classid}/mail/${projid}`,
  GET_SAVE_MAIL_FOR_CLASS_URL: (projid:number) => `mail/bulk/${projid}`,
  GET_DELETE_MAIL_FOR_CLASS_URL: (projid:number) => `mail/bulk/${projid}`,
  GET_SEND_MAIL_FOR_CLASS_URL: (projid:number) => `mail/bulk/${projid}/send`,
  GET_RESEND_MAIL_FOR_CLASS_URL: (projid:number) => `mail/bulk/${projid}/resend`,
  GET_ADD_MAIL_ATTACHMENT_FOR_CLASS_MAIL_URL: (projid:number) => `mail/bulk/${projid}/attachment`,
  GET_DELETE_MAIL_ATTACHMENT_FOR_CLASS_MAIL_URL: (projid:number, attachmentid:string) => `mail/bulk/${projid}/attachment/${attachmentid}`,
  GET_STATUS_FOR_CLASS_MAIL_URL: (projid:number) => `/mail/bulk/${projid}/status`,

  /* SUBGROUP */
  GET_MEMBERS_FOR_BASEGROUP_URL: (classid:string, groupId:string) => `/class/${classid}/group/${groupId}/members`,
  GET_FEED_FOR_BASEGROUP_URL: (classid:string, groupId:string, userId:string, filterType:number|string) => `/class/${classid}/subgroup/${groupId}/feed?filtertype=${filterType}&filterByUser=${userId}`,
  GET_FORUM_FOR_BASEGROUP_URL: (classid:string, groupId:string, userId:string, filterType:number|string) => `/class/${classid}/subgroup/${groupId}/forum?filtertype=${filterType}&filterByUser=${userId}`,
  GET_MAIL_LIST_FOR_BASEGROUP_URL: (classid:string, groupid:string) => `/class/${classid}/group/${groupid}/mail`,
  CREATE_NEW_MAIL_FOR_BASEGROUP_URL: (classid:string, groupid:string) => `/class/${classid}/group/${groupid}/mail`,
  // GET_CREATE_MAIL_FOR_CLASS_URL: (classid:string) => `/mail/bulk`,


  /* TEST RESULTS */
  GET_TEST_RESULTS_URL: (classid:string) => `/admin/class/${classid}/results`,
  GET_RESULT_EDIT_URL: ({resultId, classId}:{resultId:number, classId:string}) => `/admin/class/${classId}/results/${resultId}`,
  GET_TEST_RESULTS_BY_TEST_URL: (classid:string, testId:string) => `/admin/class/${classid}/results/${testId}/test`,
  GET_TEST_RESULTS_AS_EXCEL_URL: (classid:string) => `${API_URL}/admin/class/${classid}/resultsXL`,


  /* SINGLE MAIL */

  GET_STATUS_FOR_SINGLE_MAIL_URL: "/mail/single/status",
  GET_SINGLE_MAIL_LIST_URL: "/mail/single",
  GET_CREATE_SINGLE_MAIL_URL: "/mail/single",
  GET_SINGLE_MAIL_URL: (projid:number) => `/mail/single/${projid}`,
  GET_SAVE_SINGLE_MAIL_URL: (projid:number) => `/mail/single/${projid}`,
  GET_SEND_SINGLE_MAIL_URL: (projid:number) => `/mail/single/${projid}/send`,
  GET_DELETE_SINGLE_MAIL_URL: (projid:number) => `/mail/single/${projid}`,
  GET_ADD_MAIL_ATTACHMENT_FOR_SINGLE_MAIL_URL: (projid:number) => `/mail/single/${projid}/attachment`,
  GET_DELETE_MAIL_ATTACHMENT_FOR_SINGLE_MAIL_URL: (projid:number, attachmentId:string) => `/mail/single/${projid}/attachment/${attachmentId}`,
  GET_RECEIVERS_URL: (text:string) => `/user/find?text=${text}`,


  /*  DOCBOX ********************************** */

  GET_DOCBOX_FOR_CLASS_URL: (classid:string) => `/docbox/${classid}/studentclassstudents`,
  GET_DOCBOX_FOR_CLASSTEACHER_URL: (classid:string) => `/docbox/${classid}/studentclassteachers`,
  DOCBOX_START_URL: `/docbox/start`,
  DOCBOX_CREATE_FOLDER_URL: `/docbox/CreateFolder`,
  DOCBOX_SAVE_UPDATE_FILE_URL: `/docbox/saveorupdatefile`,
  DOCBOX_TRASH_URL: `/docbox/trash`,
  DOCBOX_SHARED_TRASH_URL: `/docbox/sharedtrash`,

  GET_DOCBOX_USER_AND_GROUP_SEARCH_URL: (userid:string, type:string, groupScope:string, text:string) => `/docbox/list/${userid}/${type}/${groupScope}/usersandgroups?text=${text}`,
  DOCBOX_SAVE_UPDATE_CLASSFILE_URL: (classid:string, fileid:string) => `/class/${classid}/file/${fileid}`,


  /**
   * type 30 = file, 31 = folder
   * 
   * params {string} objectid  
   * params {30 | 31} type  
   */
  GET_DOCBOX_PERMISSIONS_URL: (objectid:string, type:string) => `/docbox/getPermissions?id=${objectid}&type=${type}`,
  DOCBOX_SET_PERMISSIONS_URL: `/docbox/setPermission`,
  DOCBOX_DELETE_PERMISSIONS_URL: `/docbox/deletepermission`,
  GET_DOCBOX_SHARED_FILE_DATA_URL: (fileid:string) => `/docbox/${fileid}/shares`,

  GET_DOCBOX_SHARED_URL: (scope:number) => `/docbox/${scope}/shared`,
  GET_DOCBOX_DELETEINFO_URL: (fileid:string) => `/docbox/${fileid}/DeleteFileInfo`,
  GET_DOCBOX_DOWNLOAD_URL: (fileid:string) => `/docbox/${fileid}/download`,

  GET_DOCBOX_MOVE_FILE_URL: (fileid:number) => `/docbox/${fileid}/movefile`,
  GET_DOCBOX_TRASH_FILE_URL: (fileid:number) => `/docbox/${fileid}/trashfile`,
  GET_DOCBOX_UNTRASH_FILE_URL: (fileid:number) => `/docbox/${fileid}/untrashfile`,
  GET_DOCBOX_DELETE_FILE_URL: (fileid:number) => `/docbox/${fileid}/deletefile`,

  GET_DOCBOX_RENAME_FOLDER_URL: (folderid:string) => `/docbox/${folderid}/RenameFolder`,
  GET_DOCBOX_TRASH_FOLDER_URL: (folderid:string) => `/docbox/${folderid}/trashfolder`,
  GET_DOCBOX_UNTRASH_FOLDER_URL: (folderid:string) => `/docbox/${folderid}/untrashfolder`,
  GET_DOCBOX_DELETE_FOLDER_URL: (folderid:string) => `/docbox/${folderid}/deletefolder`,

  GET_DOCBOX_EMPTY_TRASH_URL: (rootId:string) => `/docbox/${rootId}/EmptyTrash`,
  GET_DOCBOX_TRANSFER_TO_TEMP_URL: (fileId:string) => `/docbox/${fileId}/TransferToTemp`,

  /* IMAGE */
  GET_IMAGE_THUMB_URL: (imageid:string) => `${API_HOST}/image/get/${imageid}/thumbnail`,
  GET_IMAGE_URL: (imageid:string) => `${API_HOST}/image/get/${imageid}`,
  GET_IMAGE_PROXY_URL: (url:string) => `${API_HOST}/image/get/proxy?url=${ encodeURIComponent(url)}`,


  /* USER */
  USER_CURRENT_CLASSID_URL: `/user/currentclassid`,
  GET_USER_POLICY_TEXT_URL: (userid:string) => `/user/${userid}/GetPolicyText`,
  GET_USER_COOKIE_APPROVE_URL: (userid:string) => `/user/${userid}/SetCookieApproved`,
  GET_USER_POLICY_APPROVE_URL: (userid:string) => `/user/${userid}/SetPolicyApproved`,
  GET_USER_IMAGE_URL: (id:string) => `${API_URL}/user/${id}/image`,
  GET_USER_IMAGE_DELETE_URL: (id:string) => `${API_URL}/user/${id}/image/delete`,
  GET_USER_DATA_URL: (userid:string, classid:string) => `/user/${userid}/${classid}/detail`,
  GET_USER_SAVE_DATA_URL: (userid:string, classid:string) => `/user/${userid}/${classid}/update`,

  GET_USER_SAVE_PASSWORD_URL: (userid:string) => `/user/${userid}/password`,
  GET_USER_ISUNIQUE_URL: (propname:string, value:string, userid:string) => `/user/Property/${propname}/check?value=${encodeURIComponent(value)}&testThisUser=${userid}`,
  GET_USER_SESSIONS_URL: (userid:string, startdate:Date, enddate:Date) => `/user/${userid}/UserSessionStatistics?begin=${encodeURIComponent(startdate.toISOString())}&end=${encodeURIComponent(enddate.toISOString())}`,
  GET_USER_PROGRESS_URL: ( userid:string,classid:string) => `/user/${userid}/UserProgress${ classid ? "?classid=" + classid : "" }`,
  GET_USER_FIND_URL: (text:string, param:string, value:string) => `/user/find/?text=${text}&${param}=${value}`,

  /** KOLLA DENNA */
  GET_USER_SWITCH_URL: () => `/login/switch`,  // use w POST
  GET_USER_SWITCH_BACK_URL: () => `/login/switchback`,  // use w POST

  GET_USER_TEST_EMAIL_SETTINGS_URL: (userId:string, state:string) => `/user/${userId}/${state}/SetAllowTestResultEmails`,
  GET_USER_CONTENT_CHANGED_EMAIL_SETTINGS_URL: (userId:string, state:string) => `/user/${userId}/${state}/SetAllowCourseChangedEmails`,
  GET_USER_EMAIL_VERIFY_URL: (id:string, index:number|string) => `/user/${id}/detail/email/${index}/SendVerification`,
  GET_USER_VERIFY_EMAIL_NOW_URL: (id:string, index:number|string) => `/user/${id}/${index}/VerifyEmail`,
  GET_USER_TIMETABLESETTINGS_URL: "timetablesettings",

  GET_USER_NAME_PW_CHANGE: (userid:string, key:string, date:string, ticket:string) => `/login/GetUserName/${userid}/${key}/${date}/${ticket}`,
  GET_VERIFY_EMAIL_LINK: (signature:string, stamp:string, ticket:string) => `/mail/getverifyemaildata/${ticket}/${stamp}/${signature}`,
  PW_CHANGE_URL: "/login/ChangePasswd",

    // Register
  GET_SIGN_ON_DATA_URL: ({classid, formid}:{classid:string, formid:string}) => `/registration/GetRegistrationData/${classid}/${formid}`,
  GET_SEND_VERIFICATION_URL: ({email, langId, classid}:{email:string, langId:string, classid:string}) => `/registration/SendConfirmationCode?email=${email}&langId=${langId}&classid:string=${classid}`,
  POST_SIGN_ON_DATA_URL:  `/registration/RegisterUserToClass`,


  /* TESTS */
  GET_START_TEST_URL: (classid:string, testType:string, testId:string) => `/class/${classid}/test/${testType}/${testId}/start`,
  GET_TEST_STATUS_URL: (classid:string, testId:string) => `/class/${classid}/test/${testId}/status`,
  GET_TEST_TYPENAME_URL: (classid:string, testId:string) => `/class/${classid}/test/${testId}/type`,

  GET_SUBMIT_MCTEST_ANSW_URL: (classid:string, testId:string, session:string) => `/class/${classid}/test/multiplechoice/${testId}/answer/${session}`,
  GET_CHECK_MCTEST_ANSW_URL: (classid:string, testId:string, session:string) => `/class/${classid}/test/multiplechoice/${testId}/check/${session}`,
  GET_SUBMIT_MCTEST_URL: (classid:string, testId:string, session:string) => `/class/${classid}/test/multiplechoice/${testId}/submit/${session}`,
  GET_USER_LEFT_MCTEST_URL: (classid:string, testId:string, session:string) => `/class/${classid}/test/multiplechoice/${testId}/${session}/userleft`,
  GET_SUBMIT_QATEST_URL: (classid:string, testId:string) => `/class/${classid}/test/qa/${testId}/submit`,
  GET_SUBMIT_MQATEST_URL: (classid:string, testId:string) => `/class/${classid}/test/multiplequestion/${testId}/submit`,

  GET_POST_FILE_TO_TEST_URL: (classid:string, testId:string) => `/class/${classid}/test/fileupload/${testId}/AddFile`,
  GET_REMOVE_FILE_FROM_TEST_URL: (classid:string, testId:string) => `/class/${classid}/test/fileupload/${testId}/RemoveFile`,
  GET_SUBMIT_FILETEST_URL: (classid:string, testId:string) => `/class/${classid}/test/fileupload/${testId}/submitanswer`,

  GET_SUBMIT_CONFIRMTEST_URL: (classid:string, testId:string) => `/class/${classid}/test/simplyreply/${testId}/submit`,

  GET_SUBMIT_DRAWINGTEST_URL: (classid:string, testId:string) => `/class/${classid}/test/drawingtest/${testId}/submit`,
  GET_CHECK_DRAWINGTEST_URL: (classid:string, testId:string) => `/class/${classid}/test/drawingtest/${testId}/check`,

  GET_DELETE_TEST_RESULT_URL: (classid:string, resultId:number) => `/admin/class/${classid}/results/${resultId}`,

  /*   LECTURE */
  GET_LECTURE_DATA_URL: (classid:string, lectureid:string, height:number, width:number, density:number) => `/class/${classid}/lecture/${lectureid}/player?height=${height}&pixelDensity=${density}&width=${width}`,
  GET_LOG_SCREEN_URL: (screenid:string) => `/screen/${screenid}/view/`,
  GET_LOG_SCREEN_VIEWS_URL: (screenid:string) => `/screen/${screenid}/screenviews`,

  /* EVAL */
  SUBMIT_EVAL_URL: (classid:string, partId:string) => `/class/${classid}/coursepart/${partId}/eval`,

  /* SYSTEM CALLS */
  GET_S3_TOKEN_URL: `/s3fileupload/GetToken`,
  GET_CDN_COOKIE_URL: `/amazon/cloudfront/cookies/url`,

  /* GRAPH API */
  D3_LOCALE_FORMTS_URL: `/D3GraphApi/localeFormats`,
  GET_CLASS_LOGGED_IN_STAT_URL: (classid:string) => `${API_URL}/admin/class/${classid}/loggedInStatAslist`

};